export default "__VITE_ASSET__3bd8c82e__"